import { useContext } from "react";
import { ThemeContext, ThemeContextValue } from "./ThemeProvider";

export const useTheme = (): ThemeContextValue => useContext(ThemeContext);
